module.exports = __webpack_public_path__ + "static/media/projecthub.10b32956.png";